import { Grid, Typography, IconButton, Chip } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import { TextField } from "@aclymatepackages/atoms";

import { useCachedDisplayData } from "../../../helpers/firebase";

const TagDisplayChip = ({ tag, customTags, editCustomTags }) => {
  const isTagSelected = customTags.includes(tag);

  return (
    <Chip
      label={tag}
      variant={isTagSelected ? "filled" : "outlined"}
      deleteIcon={isTagSelected ? <CancelIcon /> : null}
      onDelete={
        isTagSelected &&
        (() => editCustomTags(customTags.filter((t) => t !== tag)))
      }
      onClick={!isTagSelected && (() => editCustomTags([...customTags, tag]))}
    />
  );
};

const DocumentationCustomTags = ({
  newTag,
  setNewTag,
  customTags,
  editCustomTags,
}) => {
  const [documentation] = useCachedDisplayData("documentation-files");

  const existingTags = [
    ...new Set(
      documentation
        .flatMap((doc) => doc.customTags || [])
        .filter((tag) => !customTags.includes(tag)),
    ),
  ].sort();

  const displayTags = [...customTags, ...existingTags];

  return (
    <>
      <Typography variant="h6" gutterBottom color="textSecondary">
        Add a Custom Tag
      </Typography>
      <Grid container direction="column" spacing={2}>
        {!!displayTags.length &&
          displayTags.map((tag) => (
            <Grid item key={tag}>
              <TagDisplayChip
                tag={tag}
                customTags={customTags}
                editCustomTags={editCustomTags}
              />
            </Grid>
          ))}
        <Grid item container spacing={1} alignItems="center">
          <Grid item xs={10}>
            <TextField
              value={newTag}
              setValue={setNewTag}
              label="New custom tag"
            />
          </Grid>
          <Grid item xs={2}>
            <IconButton
              size="small"
              onClick={() => {
                editCustomTags([...customTags, newTag]);
                return setNewTag("");
              }}
              disabled={!newTag}
            >
              <AddCircleIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default DocumentationCustomTags;
